// TODO implement custom response

import { CSRF_TOKEN_KEY } from "@constants";

// clearStore?
export const proceedThunk =
  (endpoint, { withLogout } = { withLogout: true }) =>
  async (payload, { rejectWithValue }) => {
    /* TODO
      when fetch method fails with 413 status code then action catches error after calling 
        const response = await endpoint(payload);
      and error is `Failed to fetch` string (this error goes from ingress request size limitations,
        for our case it's just uploading file with size more than ingress limit on respeecher-auth service).
      perhaps we need to check how to properly catch error code from native fetch or check how axios work with this
    */
    const response = await endpoint(payload);
    const data = await response.json();
    if (!response.ok) {
      if (response.status === 401) {
        if (withLogout) {
          document.location.href = "/";
          localStorage.removeItem(CSRF_TOKEN_KEY);
        }
        // Always reject on a non-ok response. Previously the 401 branch fell
        // through to `return data`, so a failed request was reported as a
        // fulfilled thunk carrying an error body and reducers wrote garbage
        // into state.
        return rejectWithValue(data?.detail || "Unauthorized");
      }
      if (response.status === 429) {
        // FIXME create universal solution?
        return rejectWithValue({
          statusCode: response.status,
          retryAfter: data?.detail?.["Retry-After"]
            ? data?.detail?.["Retry-After"]
            : undefined,
        });
      }
      if (response.status === 413) {
        return rejectWithValue("File is too large");
      }
      return rejectWithValue(data?.detail);
    }
    return data;
  };
